import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { convertToNumber } from "@utils/appUtils";

import { getMldJobMap } from "./mldJobMap.utils";

/**
 * Tracks in-flight MLD report jobs, reacting to sessionStorage changes via
 * the "mldJobMapUpdated" custom event.
 *
 * Returns:
 *  - currentProjectId    — the Redux project ID (or null)
 *  - currentProjectJobId — job ID running for the currently-open project (or null)
 *  - otherProjectId      — project ID of the first job that belongs to a different project (or null)
 *  - otherProjectJobId   — job ID for that other project (or null)
 */
export const usePendingMldJob = () => {
  const currentProjectId = useSelector(state => state.projectInfo.data?.projectID) ?? null;
  const [jobMap, setJobMap] = useState(() => getMldJobMap());

  useEffect(() => {
    const update = () => setJobMap(getMldJobMap());
    window.addEventListener("mldJobMapUpdated", update);
    return () => window.removeEventListener("mldJobMapUpdated", update);
  }, []);

  const currentProjectJobId = currentProjectId ? (jobMap[String(currentProjectId)] ?? null) : null;

  const otherEntry = Object.entries(jobMap).find(([pid]) => convertToNumber(pid) !== convertToNumber(currentProjectId));

  return {
    currentProjectId,
    currentProjectJobId,
    otherProjectId: otherEntry?.[0] ?? null,
    otherProjectJobId: otherEntry?.[1] ?? null,
  };
};
